import { Layout, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Content } = Layout;
const { Title, Text } = Typography;

/**
 * Shown when the URL carries no usable invitation, instead of a spinner that can
 * never resolve. The app is query-param driven with no router, so this stands in
 * for a 404 route: reaching it means `fanGroupSlug`, `waitingListId` or `code` is
 * missing, or the API rejected the code (expired, revoked, already consumed).
 */
export function InvalidLink() {
  const { t } = useTranslation();

  return (
    <Content
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: 24,
        textAlign: 'center',
        minHeight: '60vh',
      }}
    >
      <Title
        level={1}
        style={{ marginBottom: 0, fontSize: 24 }}
        data-testid="invalidLinkHeading"
      >
        {t('guest_app_invalid_link_title')}
      </Title>
      <Text type="secondary">{t('guest_app_invalid_link_text')}</Text>
    </Content>
  );
}
